import { getVoiceForId, tts } from 'component_utils/utils';
import { ICurrentDeviceConfig } from 'utils/API';
import { OnEnterArgs, State } from '..';

interface EventProps {
  deviceConfig: ICurrentDeviceConfig;
}

interface Config<S, P, A, R> {
  nextState: number;
  getText: (args: OnEnterArgs<S, P, R>) => Promise<string>;
}

const StateSpeech = function <S, P extends EventProps, A extends {}, R>({
  nextState,
  getText,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      const text = await getText(args);
      const { deviceConfig } = args.props;
      if (text) {
        tts(getVoiceForId(deviceConfig.TTSVoice), text, deviceConfig.TTSRate);
      }
      return {
        type: 'MOVE',
        nextState: nextState,
      };
    },

    nodeName: 'T.states.speech',
    outputs: [
      {
        name: 'after',
        to: nextState,
      },
    ],
  };
};

export default StateSpeech;
